import * as commonUtils from '@dbp-toolkit/common/utils';
import {LanguageSelect} from './language-select.js';

commonUtils.defineCustomElement('dbp-language-select', LanguageSelect);
